import React, { Component } from "react";

class ErrorMessage extends Component {
  constructor(props) {
    super(props);
    this.state = { showDetail: false };
  }

  render() {
    return (
      <div className="alert alert-error">
        <p>
          <b>
            Oh snap. It looks like there's a problem with the backend. Please
            try again.
          </b>
        </p>
        <div>
          <button
            className="btn btn-mini"
            onClick={() =>
              this.setState({ showDetail: !this.state.showDetail })
            }
          >
            {this.state.showDetail ? "Hide Details" : "Show Details"}
          </button>
          <br />
          {this.state.showDetail && <pre>{this.props.error.toString()}</pre>}
        </div>
      </div>
    );
  }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/utils/ErrorMessage.js